import * as service from './service'
export default {
  namespace: 'customerServiceAnnex',
  state: {
    demoData: {}
  },
  effects: {
    * supplyMaterial ({ payload }, { call, put }) {
      const res = yield call(service.supplyMaterial, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
